import { useCallback } from 'react';

import { jump_to_specific_scene_set } from '@bighealth/api/SceneSetGraph/v1';

import { useSafeParams } from 'components/Routes/useSafeParams';

import { queryClientJumpToSceneSet } from '../queryClientAnalogs/queryClientJumpToSceneSet';

import { useLazyQueryDownloadSceneSetAssets } from './useLazyQueryDownloadSceneSetAssets';

export type JumpCallback = (
  args: jump_to_specific_scene_set.Args
) => Promise<undefined | jump_to_specific_scene_set.Response>;

export const useLazyQueryJumpToSceneSetWithAssets = (): JumpCallback => {
  const downloadAssets = useLazyQueryDownloadSceneSetAssets();
  const { productReference } = useSafeParams();

  return useCallback(
    async args => {
      try {
        const response = await queryClientJumpToSceneSet(
          args,
          productReference
        );
        const sceneSetJSON = response?.result?.scene_set_json;
        await downloadAssets(sceneSetJSON);
        return response;
      } catch (e) {
        return e;
      }
    },
    [downloadAssets, productReference]
  );
};
